// @flow

import orderFormReducer from './reducers';
import { fetchAddress } from './actions';

export {
  fetchAddress,
};

export default orderFormReducer;
